import type { ChatStoreState } from "./types";

export const state = (): ChatStoreState => ({
  chatEnabled: false,
  showChat: false,
  messages: [],
  stickers: [],
  chatStatus: "",
  tabDisabled: false,
});
